
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 800 238","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"app-inline-svg",attrs:{"transform":"translate(14 7)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M48 0h59v18H48zM734 47h33v13h-33zM48 47h177v13H48zM48 26h230v13H48z"}}),_c('circle',{attrs:{"cx":"16.5","cy":"16.5","r":"16.5"}}),_c('path',{attrs:{"d":"M111 161h59v18h-59zM111 208h177v13H111zM111 187h230v13H111z"}}),_c('circle',{attrs:{"cx":"79.5","cy":"177.5","r":"16.5"}}),_c('path',{attrs:{"d":"M48 75h59v18H48zM734 122h33v13h-33z"}}),_c('path',{attrs:{"opacity":".776","d":"M48 153h719v78H48z"}}),_c('path',{attrs:{"d":"M48 122h177v13H48zM48 101h480v13H48z"}}),_c('circle',{attrs:{"cx":"16.5","cy":"91.5","r":"16.5"}}),_c('path',{attrs:{"d":"M715 208h33v13h-33z"}})])])
          )
        }
      }
    